import { Component, VERSION } from '@angular/core';
import {CommonModule} from '@angular/common';
import { HttpModule } from '@angular/http';
import { NgxPermissionsService, NgxRolesService, NgxPermissionsDirective } from 'ngx-permissions';


@Component({
  selector: 'app-dashboard',
  styleUrls: ["../../../styles.css"],
  templateUrl: './full-layout.component.html'
})
export class FullLayoutComponent { 

	private navigation:any = [];
	constructor(private NgxRolesService: NgxRolesService, private NgxPermissionsService: NgxPermissionsService) {

	    this.navigation = [];
		console.log(localStorage.getItem('currentUserMainPermissions'));

	    if((localStorage.getItem('currentUserMainPermissions')).indexOf('dashboard') > -1){
	    	this.navigation.push({
			    name: 'Dashboard',
			    url: '/dashboard',
			    icon: 'icon-speedometer',
			  });
	    }
	    if((localStorage.getItem('currentUserMainPermissions')).indexOf('calendar') > -1){
	    	this.navigation.push({
			    name: 'Calendar',
			    url: '/calendar',
			    icon: 'icon-calendar',
			  });
	    }
	    if ((localStorage.getItem('currentUserMainPermissions')).indexOf('events') > -1) {
			const eventsNavItem = {
			  name: 'Events',
			  url: '/',
			  icon: 'icon-note',
			  children: [
				{
				  name: 'Events List',
				  url: '/events',
				  icon: 'icon-list',
				},
				// {
				//   name: 'Events Invoice',
				//   url: '/eventinvoice',
				//   icon: 'icon-list',
				// },
				// {
				//   name: 'Events Status',
				//   url: '/project-status',
				//   icon: 'icon-list',
				// },
				// Add "Event Logs" conditionally
			  ],
			};
		  
			// Conditionally add "Event Logs" based on currentUserRoleId
			if (localStorage.getItem('currentUserRoleId') === '5af91f2e201e873904eb02ba') {
			  eventsNavItem.children.push({
				name: 'Event Logs',
				url: '/events/eventlog',
				icon: 'icon-list',
			  });
			}
			 if((localStorage.getItem('currentUserMainPermissions')).indexOf('eventstatus') > -1){
				eventsNavItem.children.push({
				  name: 'Events Status',
				  url: '/project-status',
				  icon: 'icon-list',
				});
	    	}
			if((localStorage.getItem('currentUserRole') === "ADMIN")){
				eventsNavItem.children.push({
					name: 'Events Invoice',
					url: '/eventinvoice',
					icon: 'icon-list',
				});
			}
			if((localStorage.getItem('currentUserMainPermissions')).indexOf('package') > -1){
				eventsNavItem.children.push({
					name: 'Event Packages',
					url: '/packages',
					icon: 'icon-list',
				  });
			}
			if((localStorage.getItem('currentUserRole') === "ADMIN")){
				eventsNavItem.children.push({
					name: 'Events Services',
					url: '/services',
					icon: 'icon-list',
				});
			}
			//   {
				// 	name: 'Services',
				// 	url: '/services',
				// 	icon: 'icon-list',
				//   },
		  
			this.navigation.push(eventsNavItem);
		  }
		  
	    // if((localStorage.getItem('currentUserRole') === "ADMIN")){
	    // 	this.navigation.push({
		// 	    name: 'Invoices',
		// 	    url: '/eventinvoice',
		// 	    icon: 'icon-layers',
		// 	  });
	    // }
	    if((localStorage.getItem('currentUserMainPermissions')).indexOf('dealers') > -1){
	    	this.navigation.push({
			    name: 'Dealers',
			    url: '/dealers',
			    icon: 'icon-user',
			  });
	    }
	    if((localStorage.getItem('currentUserMainPermissions')).indexOf('staff') > -1){
	    	this.navigation.push({
			    name: 'Staff',
			    url: '/staff',
			    icon: 'icon-people ',
			  });
	    }
	    // if((localStorage.getItem('currentUserMainPermissions')).indexOf('package') > -1){
	    // 	this.navigation.push({
		// 	    name: 'Event Packages',
		// 	    url: '/packages',
		// 	    icon: 'icon-notebook ',
		// 	  });
	    // }
	    if((localStorage.getItem('currentUserMainPermissions')).indexOf('address') > -1){
	    	this.navigation.push({
			    name: 'Address',
			    url: '/address',
			    icon: 'icon-notebook',
			  });
	    }
	    if((localStorage.getItem('currentUserMainPermissions')).indexOf('dataupload') > -1){
	    	this.navigation.push({
			    name: 'Data Upload',
			    url: '/dataupload',
			    icon: 'icon-list',
			  });
	    }
	     if((localStorage.getItem('currentUserMainPermissions')).indexOf('dealercontacts') > -1){
	    	this.navigation.push({
			    name: 'Contacts',
			    url: '/dealercontacts',
			    icon: 'icon-list',
			  });
	    }
	    if((localStorage.getItem('currentUserMainPermissions')).indexOf('globalproperty') > -1){
	    	this.navigation.push({
			    name: 'Global Properties',
				url: '/',
			    icon: 'icon-settings',
				children: [
			  	  {
		    		name: 'OEM',
		    		url: '/oem',
		    		icon: 'icon-list',
			  	  },
			  	  {
		    		name: 'Brands',
		    		url: '/brand',
		    		icon: 'icon-list',
			  	  },
			  	  {
		    		name: 'Centers',
		    		url: '/center',
		    		icon: 'icon-list',
			  	  },
			  	  {
			        name: 'MR',
			        url: '/mr',
			        icon: 'icon-list',
			      },
			  	  {
			        name: 'ER',
			        url: '/er',
			        icon: 'icon-list',
			      },
			      {
		    		name: 'Auto Groups',
		    		url: '/auto-group',
		    		icon: 'icon-list',
			  	  },  	  
			  	  {
		    		name: 'Advertising Agency',
		    		url: '/advertisingagency',
		    		icon: 'icon-list',
			  	  },  	  
			  	  {
		    		name: 'Dealers Contact Role',
		    		url: '/contactrole',
		    		icon: 'icon-list',
			  	  },
			  	  {
		    		name: 'Kit Type',
		    		url: '/kittype',
		    		icon: 'icon-list',
			  	  },
				//   {
				// 	name: 'Services',
				// 	url: '/services',
				// 	icon: 'icon-list',
				//   },
				  {
		    		name: 'BEST Fields',
		    		url: '/bestfield',
		    		icon: 'icon-list',
			  	  },
				  ]
				});
	    }
	    // if((localStorage.getItem('currentUserMainPermissions')).indexOf('eventstatus') > -1){
	    // 	this.navigation.push({
		// 		name: 'Event Status',
		// 		url: '/project-status',
		// 		icon: 'icon-layers',
		// 	});
	    // }
	    if((localStorage.getItem('currentUserMainPermissions')).indexOf('contracts') > -1){
	    	this.navigation.push({
					name: 'Contract Content',
					url: '/contract-content',
					icon: 'icon-docs ',
				});
	    }
	    if((localStorage.getItem('currentUserMainPermissions')).indexOf('emailcontent') > -1){
	    	this.navigation.push({
					name: 'Email Content',
					url: '/email-content',
					icon: 'icon-envelope',
				});
	    }
	    if((localStorage.getItem('currentUserMainPermissions')).indexOf('globaltrash') > -1){
	    	this.navigation.push({
				name: 'Global Trash',
				url: '/intrash',
				icon: 'fa fa-trash-o',
			});
	    }
	    if((localStorage.getItem('currentUserMainPermissions')).indexOf('area') > -1){
	    	this.navigation.push({
			    name: 'Areas',
				url: '',
			    icon: 'fa fa-map-marker',
				  children: [
			  	  {
			    		name: 'Country',
			    		url: '/country',
			    		icon: 'icon-list',
			  	  },
			  	  {
			    		name: 'State',
			    		url: '/state',
			    		icon: 'icon-list',
			  	  }
			  	  ]
			  	});
	    }
	    if((localStorage.getItem('currentUserMainPermissions')).indexOf('acl') > -1){
	    	this.navigation.push({
			    name: 'User roles',
				url: '/roles',
			    icon: 'fa fa-user-circle'
			  	});
	    }

	    // if( localStorage.getItem('currentUserRoleId') == '5af91f2e201e873904eb02ba') {
	    // 	this.navigation.push({
		// 	    name: 'Event Logs',
		// 		url: '/events/eventlog',
		// 	    icon: 'icon-note'
		// 	  	});
	    // }

	    if((localStorage.getItem('currentUserMainPermissions')).indexOf('offdays') > -1) {
	    	this.navigation.push({
			    name: 'Off Days',
				url: '/offDays',
			    icon: 'icon-calendar'
			  	});
	    }
	    if( localStorage.getItem('currentUserRoleId') == '5af91f2e201e873904eb02ba') {
	    	this.navigation.push({
			    name: 'Holidays',
				url: '/holidays',
			    icon: 'icon-calendar'
			  	});
	    }
				
			  	this.navigation = [...this.navigation];

		this.NgxRolesService.flushRoles();

	    if(localStorage.getItem('currentUserRole') != null) { 
	   	this.NgxRolesService.addRole(localStorage.getItem('currentUserRole'), ['A'] );
	   } else {
	   	this.NgxRolesService.addRole("GUEST", ['A'] );	   
	   }

	    let roles = NgxRolesService.getRoles();
	    NgxRolesService.roles$.subscribe((data) => {
	       
	    })
  }

public isDivider(item) {
    return item.divider ? true : false
  }

  public isTitle(item) {
    return item.title ? true : false
  }

}



// WEBPACK FOOTER //
// /var/www/portal/bullseye/src/app/containers/full-layout/full-layout.component.ts